import * as React from 'react';
import {getLanguage} from '../../Util/language';

const lang = getLanguage();
const orIcon = require('../../resource/img/or-' + lang + '.svg');

class EnquirySeparator extends React.Component {

    public render() {
        return (
            <div className="enquirySeparator">
                <div className="orSeparator"/>
                <img src={orIcon}/>
                <div className="orSeparator"/>
            </div>
        );
    }
}

export default EnquirySeparator;



// WEBPACK FOOTER //
// ./src/Components/Enquiry/EnquirySeparator.tsx